import { SmileSmall } from "@wix/wix-ui-icons-common";
import {
  getFakeReferenceElement,
  quickActionsModalSections
} from "./../wix-rich-content-common";
import { DEFAULT_CONFIG } from "./constants";
import { getAddButtons } from "./getAddButtons";
import EmojiInsertModal from "./modals/InsertModal";
import { EMOJI_TYPE, emojiModals } from "./types";
const pluginEmoji = (config) => {
  return {
    config: { ...DEFAULT_CONFIG, ...config },
    type: EMOJI_TYPE,
    getAddButtons: (config2, services) => getAddButtons(config2, services),
    getQuickActions: () => [
      {
        id: "emoji",
        title: "QuickActionsPlugin_ActionTitle_Emoji",
        icon: SmileSmall,
        section: quickActionsModalSections.FormatLayout,
        command: ({ modalService, editor }) => modalService.openModal({
          id: emojiModals.insert,
          Component: EmojiInsertModal,
          componentProps: {},
          layout: "popover",
          positioning: {
            referenceElement: getFakeReferenceElement(editor),
            placement: "bottom-end"
          },
          onClickOutside: () => {
            modalService.closeModal(emojiModals.insert);
          }
        })
      }
    ]
  };
};
export {
  pluginEmoji
};
//# sourceMappingURL=editor.js.map
